import { render, staticRenderFns } from "./ViewRenameMigration.vue?vue&type=template&id=a91ba384&"
import script from "./ViewRenameMigration.vue?vue&type=script&lang=ts&"
export * from "./ViewRenameMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports